














































































































































import Vue from "vue"
import {BaseApiResponse} from "~/interfaces/general";

let counter: ReturnType<typeof setInterval>;

export default Vue.extend({
  name: "resetpw",
  layout: "auth",
  head: {
    title: "Восстановление пароля"
  },
  auth: false,
  data: () => ({
    step: 1,
    disableNext: false,
    isValidStep1: false,
    isValidStep2: false,
    email: "",
    code: "",
    sendCodeRepeatCountdown: 0,
    sendCodeRepeatCountdownDefault: 60,
    rules: {
      code: [
        (v: any) => !!v || "Ведите код подтверждения",
        (v: any) => (v.length >= 4) || "Введите код подтверждения"
      ],
      email: [
        (v: any) => !!v || "Заполните E-mail",
        (v: any) => /.+@.+\..+/.test(v) || "Введите корректный E-mail"
      ]
    }
  }),
  computed: {
    errorData() {
      return this.$store.getters['errorMessageData/getError'].resetpw;
    }
  },
  methods: {
    sendCode() {
      this.$api("resetPassword", {email: this.email}, "PUT")
        .then((response: BaseApiResponse) => {
          let result = response.data.result;
          if (typeof result === 'boolean') {
            this.sendCodeRepeatCountdown = this.sendCodeRepeatCountdownDefault;
            clearInterval(counter);
            counter = setInterval(() => {
              this.sendCodeRepeatCountdown = this.sendCodeRepeatCountdown - 1;
              if (this.sendCodeRepeatCountdown === 0) {
                clearInterval(counter);
              }
            }, 1000);
          } else {
            this.sendCodeRepeatCountdown = Number(result);
            clearInterval(counter);
            counter = setInterval(() => {
              this.sendCodeRepeatCountdown = this.sendCodeRepeatCountdown - 1;
              if (this.sendCodeRepeatCountdown === 0) {
                clearInterval(counter);
              }
            }, 1000);
          }
          this.step = 2;
        })
        .catch((error: BaseApiResponse) => {
          const message = error.message ? error.message : "Произошла ошибка. Попробуйте позднее.";
          this.$store.dispatch('errorMessageData/set', {message: message, block: 'resetpw'});
        })
    },
    resetPassword() {
      this.$api("resetPassword", {email: this.email, code: this.code}, "PUT")
        .then((response: BaseApiResponse) => {
          if (response.data.result && response.data.result === true) {
            this.step = 3;
          } else {
            const message = response.message ? response.message : "Некорректный код."
            this.$store.dispatch('errorMessageData/set', {message: message, block: 'resetpw'});
          }
        })
        .catch((error: BaseApiResponse) => {
          const message = error.message ? error.message : "Произошла ошибка. Попробуйте позднее."
          this.$store.dispatch('errorMessageData/set', {message: message, block: 'resetpw'});
        })
    },
    resendCode() {
      this.sendCode();
    },
    prevStep() {
      this.step = 1;
    },
    hideErrorMessage() {
      this.$store.dispatch('errorMessageData/clear', 'resetpw')
    }
  }
});
